const { requestManager } = require('../../requestManager');

const { API_PATH } = require('../../config/config');

class CancelApi {
  findByRsvSetId = async (rsvSetId = null) => {
    const filter = { rsv_set_id: rsvSetId, enable: true };
    const params = { filter };
    const response = await requestManager.get(`${API_PATH}/cancel/r/initial-search-cancel`, params);

    return response.data;
  };

  /**
   * 受付トランの更新（受付IDで更新）
   * @param {*} readyFlag
   * @param {*} readyDate
   */
  updateReception = async (receptionId, uStat, cancelList, reasonOther) => {
    await requestManager.put(`${API_PATH}/cancel/u/reception-cancel`, {
      receptionId,
      uStat,
      cancelList,
      reasonOther,
    });
  };
}

export default new CancelApi();
